import { render, staticRenderFns } from "./vector.vue?vue&type=template&id=161667f7&"
import script from "./vector.vue?vue&type=script&lang=js&"
export * from "./vector.vue?vue&type=script&lang=js&"
import style0 from "./vector.vue?vue&type=style&index=0&id=161667f7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports